import api  from './api';

interface RelatorioFilters {
    colaboradorId?: number | '';
    ramoId?: number | '';
    clienteId?: number | '';
    agenciaId?: number | '';
    empresaId?: number | '';
    dataInicio?: string;
    dataFim?: string;
}

interface RelatorioResultado {
  id: number;
  clientenome: string;
  vendedornome: string;
  ramonome: string;
  valorvendido: number;
}

export const relatorioService = {
    gerar: async (filters: RelatorioFilters): Promise<RelatorioResultado[]> => {
        const activeFilters = Object.fromEntries(
            Object.entries(filters).filter(([, value]) => value !== '' && value != null)
        );
        const params = new URLSearchParams(activeFilters as Record<string, string>);
        const response = await api.get(`/relatorios?${params.toString()}`);
        return response.data;
    }
};